// Offset ↔ (line, column) helpers shared between the scanner output assembler
// and the public DocumentStructure API. Zero-indexed throughout so the result
// matches SqlRange semantics directly.

import type { SqlRange } from '../model';

export interface LineIndex {
  starts: number[];
}

export function buildLineIndex(source: string): LineIndex {
  const starts: number[] = [0];
  for (let i = 0; i < source.length; i++) {
    if (source.charCodeAt(i) === 10) starts.push(i + 1);
  }
  return { starts };
}

function locate(idx: LineIndex, offset: number): { line: number; column: number } {
  let lo = 0;
  let hi = idx.starts.length - 1;
  while (lo < hi) {
    const mid = (lo + hi + 1) >>> 1;
    if (idx.starts[mid] <= offset) lo = mid;
    else hi = mid - 1;
  }
  return { line: lo, column: offset - idx.starts[lo] };
}

export function rangeFromOffsets(idx: LineIndex, startOffset: number, endOffset: number): SqlRange {
  const s = locate(idx, startOffset);
  const e = locate(idx, endOffset);
  return {
    startOffset,
    endOffset,
    startLine: s.line,
    startColumn: s.column,
    endLine: e.line,
    endColumn: e.column,
  };
}
